import { render, staticRenderFns } from "./BatchEditRoles.vue?vue&type=template&id=23094036&scoped=true"
import script from "./BatchEditRoles.vue?vue&type=script&lang=ts"
export * from "./BatchEditRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23094036",
  null
  
)

export default component.exports